class KlaviyoBackInStockForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.successEl = this.querySelector('[data-bis-success]');
    this.errorEl = this.querySelector('[data-bis-error]');
    this.fieldsEl = this.querySelector('[data-bis-fields]');

    this.form?.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();

    const email = this.querySelector('input[type="email"]')?.value?.trim();
    const productId = this.dataset.productId;
    const locale = this.dataset.locale;

    if (!email || !productId) return;

    const submitBtn = this.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + productId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VhjRHK', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-07-15'
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        if (response.ok || response.status === 202) {
          this.showSuccess();
          if (locale) this.upsertProfileLocale(email, locale);
        } else {
          this.showError();
          if (submitBtn) submitBtn.disabled = false;
        }
      })
      .catch(() => {
        this.showError();
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  upsertProfileLocale(email, locale) {
    fetch('https://a.klaviyo.com/client/profiles/?company_id=VhjRHK', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: { email, locale }
        }
      })
    }).catch(() => {});
  }

  showSuccess() {
    this.fieldsEl?.setAttribute('hidden', '');
    this.errorEl?.setAttribute('hidden', '');
    this.successEl?.removeAttribute('hidden');
  }

  showError() {
    this.errorEl?.removeAttribute('hidden');
  }
}

customElements.define('klaviyo-back-in-stock-form', KlaviyoBackInStockForm);
